import { render, staticRenderFns } from "./IconAddMenuBar.vue?vue&type=template&id=c8c7f794&scoped=true"
import script from "./IconAddMenuBar.vue?vue&type=script&lang=js"
export * from "./IconAddMenuBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c7f794",
  null
  
)

export default component.exports